import { Button } from './Button'

interface Props {
  stale: boolean
  lastError: string | null
  refreshing: boolean
  onRetry: () => void
}

export function ConnectivityBanner({ stale, lastError, refreshing, onRetry }: Props) {
  if (!stale) return null
  const isRate = /rate limit/i.test(lastError || '')
  const msg = isRate
    ? 'API is throttling requests — slowing poll, cached data shown.'
    : lastError
      ? `Connection issue — ${lastError}`
      : 'Showing cached data — reconnecting…'

  return (
    <div className="stale-banner show" role="status">
      <span>{msg}</span>
      <Button size="sm" disabled={refreshing} onClick={onRetry}>
        {refreshing ? 'Retrying…' : 'Retry'}
      </Button>
    </div>
  )
}
